import styled from "styled-components";
import { device } from "../../utils/Environment";

export const ProjectionContainer = styled.div`
  margin: auto;
  min-height: 40px;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media ${device.tablet} {
    width: 100%;
  }

  @media ${device.laptop} {
    width: 100%;
    flex-direction: row;
  }
`;

export const Headlining = styled.h2<Props>`
  font-family: "Alata";
  font-size: ${({ isScreenMode }: Props) => (isScreenMode ? "1.6rem" : "2rem")};
  width: 80%;
  margin: 32px auto 20px;
  padding: 14px 18px;
  text-align: center;
  letter-spacing: 0.04em;
  color: #1f1f1f;
  background: #f5f5f5;
  border-top: 2px solid #d0d0d0;
  border-bottom: 2px solid #d0d0d0;

  @media ${device.tablet} {
    width: 90%;
  }

  @media ${device.laptop} {
    width: 100%;
    padding: 18px 24px;
  }

  @media ${device.desktop} {
    margin-top: 40px;
  }
`;

export const SubHeadlining = styled.h3`
  font-family: "Alata";
  font-size: 2rem;
  line-height: 44px;
  text-align: center;
`;

export const Line = styled.hr`
  margin: 20px auto;
  width: 80%;
  border: 1px solid #000000;
`;

type Props = {
  isScreenMode: boolean;
};
